module.exports = __webpack_public_path__ + "img/solids-icon.ad40b10b.svg";